// Tremor Table [v0.0.3]
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { cx } from "../../lib/utils";
const TableRoot = React.forwardRef((_a, forwardedRef) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("div", { ref: forwardedRef },
        React.createElement("div", Object.assign({ 
            // make table scrollable on mobile
            className: cx("onvo-w-full onvo-overflow-auto onvo-whitespace-nowrap", className) }, props), children)));
});
TableRoot.displayName = "TableRoot";
const Table = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("table", Object.assign({ ref: forwardedRef, "tremor-id": "tremor-raw", className: cx(
        // base
        "onvo-w-full onvo-caption-bottom onvo-border-b", 
        // border color
        "onvo-border-gray-200 dark:onvo-border-gray-800", className) }, props)));
});
Table.displayName = "Table";
const TableHead = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("thead", Object.assign({ ref: forwardedRef, className: cx(className) }, props)));
});
TableHead.displayName = "TableHead";
const TableHeaderCell = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("th", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-border-b onvo-px-4 onvo-py-3.5 onvo-text-left onvo-text-sm onvo-font-semibold", 
        // text color
        "onvo-text-gray-900 dark:onvo-text-gray-50", 
        // border color
        "onvo-border-gray-200 dark:onvo-border-gray-800", className) }, props)));
});
TableHeaderCell.displayName = "TableHeaderCell";
const TableBody = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tbody", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-divide-y", 
        // divide color
        "onvo-divide-gray-200 dark:onvo-divide-gray-800", className) }, props)));
});
TableBody.displayName = "TableBody";
const TableRow = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tr", Object.assign({ ref: forwardedRef, className: cx("[&_td:last-child]:onvo-pr-4 [&_th:last-child]:onvo-pr-4", "[&_td:first-child]:onvo-pl-4 [&_th:first-child]:onvo-pl-4", className) }, props)));
});
TableRow.displayName = "TableRow";
const TableCell = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("td", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-p-4 onvo-text-sm", 
        // text color
        "onvo-text-gray-600 dark:onvo-text-gray-400", className) }, props)));
});
TableCell.displayName = "TableCell";
const TableFoot = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tfoot", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-border-t onvo-text-left onvo-font-medium", 
        // text color
        "onvo-text-gray-900 dark:onvo-text-gray-50", 
        // border color
        "onvo-border-gray-200 dark:onvo-border-gray-800", className) }, props)));
});
TableFoot.displayName = "TableFoot";
const TableCaption = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("caption", Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-mt-3 onvo-px-3 onvo-text-center onvo-text-sm", 
        // text color
        "onvo-text-gray-500 dark:onvo-text-gray-500", className) }, props)));
});
TableCaption.displayName = "TableCaption";
export { Table, TableBody, TableCaption, TableCell, TableFoot, TableHead, TableHeaderCell, TableRoot, TableRow, };
//# sourceMappingURL=Table.js.map